import {
  getEcommerceByIds,
  viewItemListEvent,
  selectItemEvent,
} from "@src/analytics";

const ITEM_LIST_NAME = "お気に入り";

export const getPropertyIdsFromSlides = (slides: Element[]): string[] => {
  return slides
    .map((slide) => {
      const propertyId = slide
        .querySelector(".container-shortlist-favorite")
        ?.getAttribute("data-property-id");
      return propertyId || "";
    })
    .filter((propertyId) => !!propertyId);
};

export const pushViewItemListEventFromSlides = (
  slides: Element[],
  category?: string
) => {
  const propertyIds = getPropertyIdsFromSlides(slides);
  getEcommerceByIds(propertyIds, category).then((ecommerce) => {
    viewItemListEvent({
      ...ecommerce,
      item_list_name: ITEM_LIST_NAME,
    });
  });
};

export const pushSelectItemEventFromId = (
  propertyId: string,
  category?: string
) => {
  getEcommerceByIds([propertyId], category).then((ecommerce) => {
    selectItemEvent({
      ...ecommerce,
      item_list_name: ITEM_LIST_NAME,
    });
  });
};
